import { addCommas } from '@persian-tools/persian-tools';

function convertToToman(rialPrice) {
	if (!rialPrice) return 0;

	return addCommas(Math.floor(rialPrice / 10));
}

export default convertToToman;
